import { useAppSelector } from "features/store";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

type SuperUserRouteProps = {
  children: ReactNode;
};

const SuperUserRoute = ({ children }: SuperUserRouteProps): JSX.Element => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const pp = user?.platform_profile;

  if (user && !user.is_pass_reset && !(pp && !pp.is_pass_reset)) {
    return <Navigate to="/reset-password" replace />;
  }

  if (!user || !pp?.is_superuser || pp?.is_archived) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default SuperUserRoute;
